import { ThemeProvider as NextThemesProvider } from "next-themes"
import type { ThemeProviderProps } from "next-themes"

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  return (
    <NextThemesProvider
  {...props}
  attribute="class"
  enableSystem={false}
  defaultTheme="light"
  themes={["light", "dark"]}
>
  {children}
</NextThemesProvider>
  )
}
